import { CatButton } from '@blocks-react/components/Button';
import { MyEquipmentLinkProps } from '../types';

export const MyEquipmentLink = ({
  children,
  onClick,
  className,
}: MyEquipmentLinkProps) => {
  return (
    <CatButton variant="ghost" onClick={onClick} className={className}>
      {children}
    </CatButton>
  );
};
